import React, { useEffect, useState } from "react";
import axios from "axios";

import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import {
  timeToSeconds,
  getCurrentFY,
  getDaysInFYMonths,
  months,
  secondsToHHMM,
  sumArrayOfObjects,
} from "../../../../Utilitie";

const MachineEngMonthWiseGraph = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [chartData2, setChartData2] = useState(null);
  const head = ["In Hour", "In Number"];
  const [active, setActive] = useState("In Number");

  const product = [
    "No_Of_Demand_By_Engg",
    "No_Of_Demand_Agreed_GIVEN",
    "Availed_No",
  ];
  const product2 = ["Engg_Demand", "Agreed_Demand", "Availed"];

  let years = [...new Set(data && data.map((o) => o.Month))];
  useEffect(() => {
    const chart1 = {
      dimensions: ["product", ...years],
      series: product.map((p) => {
        const obj = { product: p };

        years.forEach((year) => {
          const row = data.find((d) => d.Month === year);
          obj[year] = row?.[p] || 0;
        });

        return obj;
      }),
    };

    const chart2 = {
      dimensions: ["product2", ...years],
      series: product2.map((p) => {
        const obj = { product2: p };

        years.forEach((year) => {
          const row = data.find((d) => d.Month === year);

          obj[year] = timeToSeconds(row?.[p]) || "00:00";
        });

        return obj;
      }),
    };

    setChartData(chart1);
    setChartData2(chart2);
  }, [data.length]);

  return (
    <div>
      <div className="row">
        <hr />

        <div className="col-md-12 border-end">
          <h5 className="bg-dark p-2 text-white d-flex justify-content-between ">
            Month Wise Graph
            <select
              className="small"
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              {head.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </h5>
          {active === "In Number" && chartData && (
            <GroupedBarChart
              data={chartData}
              rotateText={0}
              from={`Block_C`}
              chartType="bar"
              height={400}
              decimal={2}
            />
          )}
          {active === "In Hour" && chartData2 && (
            <GroupedBarChart
              data={chartData2}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
              height={400}
              decimal={2}
            />
          )}{" "}
        </div>
        {/* <div className="col-md-12 border-end">
          <h5 className="bg-dark p-2 text-white">
            Month Wise Graph
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(in Hour)</b>
          </h5>
          {chartData2 && (
            <GroupedBarChart
              data={chartData2}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
              height={300}
              decimal={2}
            />
          )}{" "}
        </div> */}
        {/* <div className="col-md-3 border-end">
          <h5>
            Total Detention
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(in No)</b>
          </h5>
          {chartData4 && (
            <GroupedBarChart
              data={chartData4}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
              height={300}
              decimal={2}
            />
          )}{" "}
        </div> */}
      </div>
    </div>
  );
};
export default MachineEngMonthWiseGraph;
